import { render, staticRenderFns } from "./LinkPanel.vue?vue&type=template&id=24d13f8c&scoped=true&"
import script from "./LinkPanel.vue?vue&type=script&lang=js&"
export * from "./LinkPanel.vue?vue&type=script&lang=js&"
import style0 from "./LinkPanel.vue?vue&type=style&index=0&id=24d13f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d13f8c",
  null
  
)

export default component.exports